var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"y":"1.414","width":"2","height":"37","rx":"1","transform":"rotate(-45 0 1.414)","fill":"#fff","key":0}),React.createElement("rect",{"x":"26.163","width":"2","height":"37","rx":"1","transform":"rotate(45 26.163 0)","fill":"#fff","key":1})]);
}

Close.defaultProps = {"width":"28","height":"28","fill":"none"};

module.exports = Close;

Close.default = Close;
